import { Blueprint } from 'types';

/**
 * Extracts both hybrid and conventional calculations from blueprint
 * Base calculation (isBaseCalculation: true) is the conventional setup without batteries
 * Non-base calculation (isBaseCalculation: false) is the hybrid setup with batteries
 * @param blueprint - Blueprint data
 * @returns Object with hybrid and conventional calculations (undefined if not found)
 */
export const getBlueprintCalculations = (blueprint?: Blueprint) => {
  const conventional = blueprint?.calculations?.find((calc) => calc.isBaseCalculation);
  const hybrid = blueprint?.calculations?.find((calc) => !calc.isBaseCalculation);

  return { hybrid, conventional };
};

/**
 * Determines MIME type based on file extension
 * Supports CSV, XLS, and XLSX files for power profile uploads
 * @param fileName - Name of the file including extension
 * @returns MIME type string
 */
export const getMimeType = (fileName: string): string => {
  const extension = fileName.toLowerCase().split('.').pop();
  switch (extension) {
    case 'xlsx':
      return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    case 'xls':
      return 'application/vnd.ms-excel';
    case 'csv':
    default:
      return 'text/csv';
  }
};
